<template>
  <div class="elunittree">
    <!-- 新的Element单选设备树形控件 -->
    <div style="margin-bottom: 5px;">
      <el-input
        size="medium"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
      >
      </el-input>
    </div>
    <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
      <el-button type="primary" size="mini" @click="add" v-if="flag"
        >新增</el-button
      >
      <el-button
        type="success"
        size="mini"
        v-if="clickItem && flag"
        @click="edit"
        >修改</el-button
      >
      <el-button
        type="danger"
        size="mini"
        v-if="clickItem && flag"
        @click="delete_fn"
        >删除</el-button
      >
      <el-tree
        class="filter-tree"
        :data="dataList"
        :default-expanded-keys="defaultExpanded"
        :expand-on-click-node="true"
        node-key="id"
        :props="defaultProps"
        :highlight-current="true"
        :filter-node-method="filterNode"
        ref="tree"
        @node-click="nodeClick"
      >
        <template #default="{ node }">
          <span class="custom-tree-node">
            <img src="../../../../public/static/image/elTree/1.9.png" />
            <span style="margin-left:4px">{{ node.data.catalogueName }}</span>
          </span>
        </template>
      </el-tree>
    </el-scrollbar>
    <el-dialog
      v-dialogDrag
      :title="textMap[dialogStatus]"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="400px"
    >
      <div class="cropper-content">
        <el-form :model="temp" :rules="rules" ref="temp" label-width="100px">
          <el-form-item label="目录名称:" prop="catalogueName">
            <el-input v-model="temp.catalogueName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible = false;
            temp = {};
          "
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="dialogStatus === 'edit' ? edit_fn('temp') : add_fn('temp')"
          :loading="loading"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/api/http.js";
export default {
  props: ["flag"],
  data() {
    return {
      clickItem: "",
      textMap: {
        add: "新增",
        edit: "编辑",
      },
      dialogStatus: "",
      rules: {
        catalogueName: [
          { required: true, message: "请输入目录名称", trigger: "blur" },
        ],
      },
      loading: false,
      dialogVisible: false,
      temp: {},
      dataList: [
        { catalogueName: "1#挽拌" },
        { catalogueName: "2#揽" },
        { catalogueName: "3#挽拌" },
        { catalogueName: "1#取料" },
        { catalogueName: "2#马" },
        { catalogueName: "3#月料" },
        { catalogueName: "卸料区" },
      ],
      filterText: "",
      defaultProps: {
        children: "children",
        label: "catalogueName",
      },
      defaultExpanded: [],
      defaultDevice: "",
    };
  },

  mounted() {
    this.getTree();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  methods: {
    delete_fn() {
      this.$confirm(`是否删除 ${this.clickItem.catalogueName}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/catalogueRunningTime/deleteById?id=" + this.clickItem.id,
          method: "delete",
        }).then((res) => {
          if (res.code == 200) {
            this.getTree();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
      });
    },
    edit() {
      this.dialogStatus = "edit";
      this.temp = Object.assign({}, this.clickItem);
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["temp"].clearValidate();
      });
    },
    edit_fn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = this.temp;
          params.uid = params.id;
          delete params.id;
          delete params.createTime;
          this.loading = true;
          request({
            url: "/catalogueRunningTime/save",
            method: "POST",
            params,
          }).then((res) => {
            this.loading = false;
            if (res.code == 200) {
              this.getTree();
              this.temp = {};
              this.dialogVisible = false;
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "info",
              });
            }
          });
        }
      });
    },
    add_fn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = this.temp;
          this.loading = true;
          request({
            url: "/catalogueRunningTime/save",
            method: "POST",
            params,
          }).then((res) => {
            this.loading = false;
            if (res.code == 200) {
              this.getTree();
              this.temp = {};
              this.dialogVisible = false;
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "info",
              });
            }
          });
        }
      });
    },
    add() {
      this.dialogStatus = "add";
      this.dialogVisible = true;
      this.temp = {};
      this.$nextTick(() => {
        this.$refs["temp"].clearValidate();
      });
    },
    getTree() {},
    // 树形筛选
    filterNode(value, data) {
      if (!value) return true;
      return data.catalogueName.indexOf(value) !== -1;
    },
    tree_fn() {},
    nodeClick(val) {
      this.clickItem = val;
      this.$emit("checkFun", val);
    },
    digui(data) {
      var device = [];
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.hasOwnProperty("children") && row.children.length != 0) {
              getStr(row.children);
            } else {
              device.push(row);
            }
          });
        };
        getStr(data);
      };
      recursiveFunction();
      this.defaultExpanded = [device[0].no];
      this.$nextTick(() => {
        //默认选中
        this.$refs["tree"].setCurrentNode(device[0]);
        this.$emit("checkFun", device[0]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.elunittree {
  width: 100%;
  height: 100%;

  .custom-tree-node {
    display: flex;
    align-items: center;

    img {
      margin-right: 5px;
    }
  }
}
</style>
